import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { FormationCard } from '../components/FormationCard';
import { Cap360 } from '../components/Cap360';
import { CTABand } from '../components/CTABand';
import { FORMATIONS } from '../data/constants';
import { Info } from 'lucide-react';
import { Alert, AlertDescription } from '../components/ui/Alert';
export function FormationsList() {
  return <div className="flex flex-col w-full" data-id="element-1580">
      <PageHeader title="Nos Formations en Alternance" subtitle="Découvrez nos parcours diplômants dans les domaines du commerce, de la vente et de la relation client." data-id="element-1581" />

      <div className="py-24 bg-muted relative overflow-hidden" data-id="element-1582">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-1583" />
        <div className="container relative z-10" data-id="element-1584">
          <div className="max-w-4xl mx-auto mb-20" data-id="element-1585">
            <Alert className="bg-white border-none shadow-xl p-8 rounded-3xl flex items-center gap-6 group hover:-translate-y-1 transition-transform" data-id="element-1586">
              <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1587">
                <Info className="h-8 w-8 text-brand-orange animate-soft-bounce" data-id="element-1588" />
              </div>
              <AlertDescription className="text-xl text-primary-dark font-extrabold leading-relaxed" data-id="element-1589">
                Zillenium Alternance présente uniquement les formations ouvertes
                sur des sessions confirmées.
              </AlertDescription>
            </Alert>
          </div>

          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto" data-id="element-1590">
            {FORMATIONS.map(formation => <FormationCard key={formation.id} formation={formation} data-id="element-1591" />)}
          </div>

          <div className="mt-12 max-w-3xl mx-auto" data-id="element-1592">
            <Cap360 data-id="element-1593" />
          </div>
        </div>
      </div>

      <div className="mt-24" data-id="element-1594">
        <CTABand title="Prêt à vous lancer ?" description="Rejoignez Zillenium Alternance et donnez vie à vos projets professionnels." primaryButtonText="Je candidate maintenant" primaryButtonLink="/candidater" secondaryButtonText="Je suis une entreprise" secondaryButtonLink="/entreprises" data-id="element-1595" />
      </div>
    </div>;
}